<template>
    <v-layout justify-center>
        <v-dialog v-model="show" persistent width="600px">
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Тег</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="saveValue" :disabled="!valid">
                            <v-icon>save</v-icon>
                            {{tagModel.id === null ? ' Создать' : '\t\t Сохранить'}}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list three-line subheader class="content">
                    <v-container>
                        <v-form ref="form" v-model="valid">
                            <v-row class="d-flex">
                                <v-col cols="6" class="py-0 pr-0">
                                    <v-text-field
                                            v-model="tagModel.title"
                                            :counter="50"
                                            label="Название тега"
                                            class="ma-0 pa-0 pr-2 pt-3"
                                            required
                                            :rules="[rules.required, rules.maxLengthTitle]"
                                            dense
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                right
        >
            Успешно сохранено!
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
    
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'CardForm',
    components: {
    },
    data() {
        return {
            show: false,
            snackbar: false,
            attachments: [],
            tagModel: {
                id: null
            },
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value && value.length <= 50) || 'Максимальная длина названия 28 символов.'
            },
            valid: false,
            tagModelDef: {
                id: null,
                bot_id: null,
                tag_list_id: null,
                status: 1,
                title: null,
                created_at: null
            }
        }
    },
    props: ['editTagId', 'dialog', 'tagListId'],
    methods: {
        saveValue: function () {
            if (this.tagModel.tag_list_id == null) {
                this.tagModel.tag_list_id = this.tagListId
            }
            this.$store.dispatch('cards/tagCreate', this.tagModel).then(response => {
                if (response.ok) {
                    if (this.tagModel.id == null) {
                        this.$emit('addTag', { tagModel: response.response.data, tagListId: this.tagListId })
                    } else {
                        this.$emit('updateTag', { tagModel: response.response.data, tagListId: this.tagListId })
                    }
                    this.tagModel = response.response.data
                    this.snackbar = true
                } else {
                    console.error('Ошибка в создании')
                }
            })
        },
        loadModel(tagId) {
            if (tagId === null) {
                this.tagModel = Object.assign({}, this.tagModelDef)
                this.tagModel.tag_list_id = this.tagListId
            } else {
                this.tagModel = this._.cloneDeep(this.getTagById(tagId)) // JSON.parse(JSON.stringify(this.getCardById(cardId)))// this._.cloneDeep(this.getCardById(cardId))
            }
        },
        changeCountCards({ index, count }) {
            this.saveValue()
        },
        removeCard(index) {
            this.saveValue()
        }
    },
    computed: {
        ...mapGetters({
            tags: 'cards/tags',
            cardsLoaded: 'cards/getLoadedStatus',
            getTagById: 'cards/getTagById'
        })
    },
    watch: {
        dialog() { this.dialog === true ? this.show = true : this.show = false },
        show() {
            if (this.show === false) {
                this.tagModel = Object.assign({}, this.tagModelDef)
                this.$refs.form.resetValidation()
                this.$emit('close')
            } else {
                this.loadModel(this.editTagId)
            }
        }
    },
    created() {
        this.tagModelDef.bot_id = +this.$route.params['pathMatch']
        // this.$store.dispatch('cards/changeBotIdModelDefault', this.$route.params['pathMatch'])
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }

    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
</style>
